import { request } from './api';
// 获取扫描二维码
export const GetQrCode = async (data?: any) => {
    return request({
        method: 'get',
        url: '/api/auth/community/login',
        data,
        params: data,
    });
};
// 轮询登陆状态
export const PollingQr = async (data?: any) => {
    return request({
        method: 'post',
        url: '/api/auth/community/polling',
        data,
    });
};

// 查询用户信息
export const userInfo = async (data?: any) => {
    return request({
        method: 'get',
        url: '/user/user_info',
        params: data,
    }).then((res) => res.data);
};

// 注册
export const register = async (data:any) => {
    return request({
        method: 'post',
        url: '/user/open_complex/register',
        data: {
            ...data,
            platform: 'brain',
            region: data.region.slice(1)
        },
    });
};
// 获取手机验证码
export const vericode = async (data?: any) => {
    return request({
        method: 'get',
        url: '/user/mobile_vericode',
        params: data,
    });
};
// 获取手机验证码登录
export const mobile = async (data?: any) => {
    return request({
        method: 'get',
        url: '/user/open_complex/login',
        params: {
            ...data,
        },
    });
};
// 获取邮箱验证码
export const emailVericode = async (data?: any) => {
    return request({
        method: 'get',
        url: '/user/email_vericode',
        params: {
            ...data,
        },
    });
};
// 邮箱登录
export const emailLogin = async (data?: any) => {
    return request({
        method: 'get',
        url: '/user/email/login',
        params: {
            ...data,
        },
    });
};
// 退出
export const logout = async (data?: any) => {
    return request({
        method: 'get',
        url: '/api/auth/logout',
        params: data,
    });
};
